import { Storage, StorageKey } from "./storage";
import { decodeJwt } from "jose";

async function sha256Hex(input: string): Promise<string> {
  const encoder = new TextEncoder();
  const data = encoder.encode(input);
  const hashBuffer = await crypto.subtle.digest("SHA-256", data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
}

export async function getCurrentSessionId(
  collectionId?: string
): Promise<string | null> {
  try {
    const token = Storage.get(StorageKey.TOKEN);
    if (!token) return null;

    const decoded = decodeJwt(token);
    const userId = decoded.sub as string;

    if (!userId) return null;

    const userHash = (await sha256Hex(userId)).substring(0, 8);
    const collectionHash = collectionId
      ? (await sha256Hex(collectionId)).substring(0, 5)
      : "";

    const now = new Date();
    const day = String(now.getDate()).padStart(2, "0");
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const year = String(now.getFullYear());
    const yearShort = year.substring(2);
    const dateStr = `${yearShort}${month}${day}`;

    return `${dateStr}00${collectionHash}${userHash}`;
  } catch (error) {
    console.error("Error generating session ID:", error);
    return null;
  }
}
